define('helper-misc-msToCMI',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (n) {
        var hms = "",
            dtm = new Date();

        dtm.setTime(n);

        if (isNaN(dtm)) {
            return '00:00:00';
        }

        var h = "0" + Math.floor(n / 3600000),
            m = "0" + dtm.getMinutes(),
            s = "0" + dtm.getSeconds();

        hms = h.substr(h.length - 2) + ":" + m.substr(m.length - 2) + ":";
        hms += s.substr(s.length - 2);

        return hms;
    };
});
